const renderHeaderCartCount = (count) => {
  const normalizedCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

  document.querySelectorAll('[data-zentrobad-cart-count]').forEach((badge) => {
    badge.textContent = normalizedCount > 99 ? '99+' : String(normalizedCount);
    badge.classList.toggle('hidden', normalizedCount === 0);

    const link = badge.closest('a');
    if (link) link.setAttribute('aria-label', `Warenkorb, ${normalizedCount} Artikel`);
  });
};

document.addEventListener('cart:update', async (event) => {
  let count = Number(event.detail?.resource?.item_count);

  if (!Number.isFinite(count)) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      count = Number(cart.item_count);
    } catch (_) {
      return;
    }
  }

  renderHeaderCartCount(count);
});
